import { render, staticRenderFns } from "./AddSupplyRulePage.vue?vue&type=template&id=695abead"
import script from "./AddSupplyRulePage.vue?vue&type=script&lang=js"
export * from "./AddSupplyRulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports